/* External documentation/community links keep the shop open. */
(() => {
  function newTab(link) {
    if (!link) return;
    const url = new URL(link.href, location.href);
    const community = ['wiki.sorek.uk', 'discord.com', 'www.discord.com', 'discord.gg'].includes(url.hostname);
    const wiki = url.hostname === 'github.com' && url.pathname.startsWith('/handmade0octopus/gauge.s-sorek.uk/wiki');
    if (!community && !wiki) return;
    link.target = '_blank';
    link.relList.add('noopener');
  }
  const refresh = root => root.querySelectorAll('a[href]').forEach(newTab);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(document), {once: true});
  else refresh(document);
  document.addEventListener('shopify:section:load', event => refresh(event.target));
  // Also cover links rendered later by section requests and the wiring selector.
  for (const type of ['click', 'auxclick']) {
    document.addEventListener(type, event => newTab(event.target.closest('a[href]')), true);
  }
})();
